import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeFiltration: {},
};

const activeFiltrationSlice = createSlice({
  name: 'activeFiltration',
  initialState,
  reducers: {
    setActiveFiltration: (state, action) => {
      state.activeFiltration = action.payload;
    },
    updateActiveFiltration: (state, action) => {
      const { jobId, filtration } = action.payload;
      state.activeFiltration[jobId] = filtration;
    },
  },
});

export const { setActiveFiltration, updateActiveFiltration } = activeFiltrationSlice.actions;

export const selectActiveFiltration = (state, jobId) => state.activeFiltration.activeFiltration[jobId];

export default activeFiltrationSlice.reducer;
